export default {
  title: 'Detalii fiscale',
  buttons: {
    save: 'Salvați',
  },
  toasts: {
    success: 'Informațiile au fost salvate cu succes.',
  },
};
